import { Injectable } from '@angular/core';
import { CapHeaderConfigData, CapHeaderConfigProvider } from '@cap/cap-ui';
import { UnexpectedError } from '@modules/store/error-store/data/models/unexpected-error.model';
import { EnvironmentService } from 'src/app/common/services/environment.service';
import { RestService } from 'src/app/common/services/rest/rest.service';

@Injectable({
    providedIn: 'root',
})
export class HeaderConfigService {
    static config: CapHeaderConfigData;

    async init() {
        return new Promise<void>((resolve, reject) => {
            this.rest
                .getRequest(
                    `assets/config/header/header-config.${this.environmentService.environment}.json`
                )
                .toPromise()
                .then((config: CapHeaderConfigData) => {
                    HeaderConfigService.config = config;
                    resolve();
                })
                .catch((err) => {
                    reject();
                    throw new UnexpectedError(err);
                });
        });
    }

    constructor(
        private environmentService: EnvironmentService,
        private rest: RestService
    ) {}
}

export class HeaderConfigProvider implements CapHeaderConfigProvider {
    get config(): CapHeaderConfigData {
        return HeaderConfigService.config;
    }
}
